const EVENTS = {
  USER_UPDATE: 'user/update',
  CHATS: {
    MESSAGE: 'chats/message',
    ACCEPTED: 'chats/accepted',
  },
  COMMENTS: {
    MESSAGE: 'comments/message',
  },
  REVISION: {
    ASSIGN_LAWYER: 'revision/assign-lawyer',
    SEARCH_LAWYER: 'revision/search-lawyer',
    ACCEPTED_LAWYER: 'revision/accepted-lawyer',
    NO_TAKEN_BY_LAWYER: 'revision/no-taken-by-lawyer',
    NO_FOUND: 'revision/no-found',
  },
  SEARCH_PREPARATION: {
    SEARCH_LAWYER: 'search-preparation/search-lawyer',
    ACCEPT_LAWYER: 'search-preparation/accept-lawyer',
    CLIENT_RESPONSE: 'search-preparation/client-response',
  },
  // DEV-LT-35: búsqueda de abogado externo para Revisión Documental (mirror de
  // SEARCH_PREPARATION). Antes faltaba este namespace: la Web App solo escuchaba
  // el evento legacy REVISION.SEARCH_LAWYER, que el backend ya no emite para el
  // flujo de abogado externo (solo para el interno).
  SEARCH_REVISION: {
    SEARCH_LAWYER: 'search-revision/search-lawyer',
    ACCEPT_LAWYER: 'search-revision/accept-lawyer',
    CLIENT_RESPONSE: 'search-revision/client-response',
  },
  CALLS: {
    NEW_CALL: 'calls/new-call',
    STATUS_CHANGE: 'calls/status-change',
  },
};

export default EVENTS;
